module.exports = __webpack_public_path__ + "img/galeria-plantas-ornamentales2.9f74f25c.jpg";